<div>
  <h1>{{'RESULTS.SECTIONS.BASELINE_CASHFLOW_ANALYSIS' | anessaTranslation: trigger}}</h1>
  <div id="selectBoxes" class="row fl">
    <!--START SELECTION BOXES-->
    <!-- Table/Graph Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-cash-flow-analysis-mediaType_select"
          multiple
          [(value)]="selectedMediaType"
          disableOptionCentering
          [placeholder]="'RESULTS.GENERAL.SELECT_MEDIA_TYPE' | anessaTranslation: trigger"
          (valueChange)="optionsChanged()"
          panelClass="anessa-dropdown-panel">
          <mat-option *ngFor="let opt of mediaTypes"
                      [value]="opt.value"
          >{{opt.translationId | anessaTranslation: trigger}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!--  START RESULT SELECT-->
    <div class="fl-item max-width-33">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-cash-flow-analysis-result_select"
          multiple
          disableOptionCentering
          [placeholder]="'RESULTS.GENERAL.SELECT_RESULTS' | anessaTranslation: trigger"
          [value]="selectedResults"
          (valueChange)="optionsChanged()"
          panelClass="anessa-dropdown-panel">
          <ngx-mat-select-search
            [placeholderLabel]="'RESULTS.GENERAL.SEARCH' | anessaTranslation: trigger"
            [noEntriesFoundLabel]="'RESULTS.ERRORS.NO_RESULTS' | anessaTranslation: trigger"
            class="clear-search"
            [(ngModel)]="searchCriteria"
            (ngModelChange)="onSearchChange()">
            <i class="material-icons" ngxMatSelectSearchClear>
              delete
            </i>
          </ngx-mat-select-search>
          <div class="dropdown-select-all-container">
            <mat-checkbox
              class="mat-option mat-option-multi"
              color="primary"
              (change)="inputsCheckAll($event)"
              [checked]="allInputsSelected()"
              [indeterminate]="isCheckAllIndeterminate()"
              #inputsCheckbox>
              {{ inputsCheckbox.checked ?
                ('RESULTS.GENERAL.DESELECT_ALL' | anessaTranslation: trigger) :
                ('RESULTS.GENERAL.SELECT_ALL' | anessaTranslation: trigger) }}
            </mat-checkbox>
          </div>
          <ng-container *ngFor="let group of filteredGroupData">
            <mat-option class="select-filter-option">
              <mat-checkbox
                class="mat-option mat-option-multi"
                color="primary"
                (change)="optGroupClick(group, $event)"
                [checked]="allGroupInputsSelected(group)"
                [indeterminate]="isGroupIndeterminate(group)">
                {{ translatedResultSelectGroups[group] }}
              </mat-checkbox>
            </mat-option>
            <ng-container *ngFor="let result of filteredSearchData">
              <mat-option
                style="padding-left: 30px;"
                *ngIf="result.group === group"
                [value]="result"
                (click)="optClick(result)">
                {{ translatedResultSelectOptions[result.name] }}
              </mat-option>
            </ng-container>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Currency Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-cash-flow-analysis-currency_select"
          [(value)]="selectedCurrency"
          [placeholder]="'RESULTS.GENERAL.SET_CURRENCY' | anessaTranslation: trigger"
          disableOptionCentering
          (valueChange)="optionsChanged()"
          panelClass="anessa-dropdown-panel">
          <mat-option disabled>
            {{'RESULTS.GENERAL.RATES_FROM' | anessaTranslation: trigger}}: {{ exchangeRateDate }}
          </mat-option>
          <mat-option
            *ngFor="let unit of currencyData"
            [value]="unit">{{ unit.translationId | anessaTranslation: trigger }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!--  END RESULT SELECT-->
  </div>
  <!--END SELECTION BOXES-->

  <div class="fl" *ngIf="showGraph || isShowResults()">
    <p>{{'RESULTS.GENERAL.EXCHANGE_RATES_FROM' | anessaTranslation: trigger}} <i>{{ exchangeRateDate }}</i></p>
  </div>

  <!-- START GRAPH -->
  <div class="row fl" *ngIf="isShowResults() && selectedMediaType.includes('graph') && showGraph">
    <div class="fl-item">
      <app-graph-selector
        [graphData]="graphData"
        [currencyLabel]="yAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [graphType]="'raw'"
      ></app-graph-selector>
    </div>
  </div>
  <!-- END GRAPH -->

  <!-- START TABLE -->
  <div *ngIf="showTable()">
    <results-treetable
      [resultsData]="tableData"
      [groupAggregationMethod]="aggrMethod"
      [aggregationBlackList]="['RESULTS.DATA.CASHFLOWS.TITLE']"
      [firstColumnHeader]="'RESULTS.GENERAL.YEARS' | anessaTranslation: trigger"
    ></results-treetable>
  </div>
  <!-- END TABLE -->
</div>
